var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 pages"},[_c('v-layout',{ref:"content",staticStyle:{"padding-bottom":"0"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('PageText',{attrs:{"text":_vm.text}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }